import { formValueSelector } from 'redux-form';
import { BAGGAGE_VALUES } from '../../common/utils/baggageUtils';
import { isPrimaryFlow } from '../../../common/utils/primaryFlow';
const isValidTraveler = traveler => {
  var _String;
  return typeof traveler === 'object' && ((traveler === null || traveler === void 0 ? void 0 : traveler.value) === true || ((_String = String(traveler === null || traveler === void 0 ? void 0 : traveler.value)) === null || _String === void 0 ? void 0 : _String.includes(BAGGAGE_VALUES.TRUE)) || (traveler === null || traveler === void 0 ? void 0 : traveler.value) === BAGGAGE_VALUES.COMBINED) && (traveler === null || traveler === void 0 ? void 0 : traveler.included) !== true;
};
const payload = ({
  id,
  weight,
  weightUnit
}) => ({
  travelerId: id,
  ...(weight && {
    weight
  }),
  ...(weightUnit && {
    weightUnit
  })
});
export const getGraphQlSelection = (productId, formSection) => {
  return ({
    form,
    state
  }) => {
    var _selectedTravelers;
    const formData = formValueSelector(form)(state, formSection) || {};
    let selectedTravelers;
    if (!isPrimaryFlow()) {
      var _formData$value;
      selectedTravelers = formData === null || formData === void 0 || (_formData$value = formData.value) === null || _formData$value === void 0 || (_formData$value = _formData$value.filter(({
        exclude
      }) => !exclude)) === null || _formData$value === void 0 ? void 0 : _formData$value.map(({
        value,
        weight,
        weightUnit
      }) => payload({
        id: value,
        weight,
        weightUnit
      }));
    } else {
      selectedTravelers = Object.values(formData).filter(isValidTraveler).map(value => payload({
        id: String(value === null || value === void 0 ? void 0 : value.id),
        weight: value === null || value === void 0 ? void 0 : value.weight,
        weightUnit: value === null || value === void 0 ? void 0 : value.weightUnit
      }));
    }
    return (_selectedTravelers = selectedTravelers) !== null && _selectedTravelers !== void 0 && _selectedTravelers.length ? {
      productId,
      selectionTravelerNumberOfUnits: selectedTravelers
    } : null;
  };
};
//# sourceMappingURL=getGraphQlSelection.js.map